/* eslint-disable @typescript-eslint/no-explicit-any */
import fetch from 'isomorphic-unfetch';

import { BASE_ENDPOINT } from '../constant';

export interface sitemapFilterProps {
  page: number;
  year?: number;
  month?: number;
  product_tag_id?: number;
  post_tag_slug?: string;
  language?: string;
}

export const getSitemapSettings = async (
  year?: number,
  month?: number
): Promise<any> => {
  const url = `${BASE_ENDPOINT}/post_sitemap_sel`;

  try {
    if (!url) return {};
    const res = await fetch(url, {
      method: 'GET',
    });

    return res.json();
  } catch (error) {
    console.error('Fetch Error:', error);
    return {};
  }
};

export const getSitemaps = async (props: sitemapFilterProps): Promise<any> => {
  const { page, year, month, post_tag_slug, language } = props;
  const baseUrl = `${BASE_ENDPOINT}/post_sitemap`;
  const hasFilter =
    !!page || !!year || !!month || !!post_tag_slug || !!language;

  const url =
    baseUrl +
    (hasFilter ? '?' : '') +
    (page ? `page=${page}` : '') +
    (year ? `&year=${year}` : '') +
    (month ? `&month=${month}` : '') +
    (post_tag_slug ? `&post_tag_slug=${post_tag_slug}` : '') +
    (language ? `&language=${language}` : '');

  try {
    if (!url) return {};
    const res = await fetch(url, {
      method: 'GET',
    });

    return res.json();
  } catch (error) {
    console.error('Fetch Error:', error);
    return {};
  }
};

export default getSitemapSettings;
